{
  "chart": {
    "empty": {
      "description": "Aucune donnée disponible pour cette période.",
      "title": "Aucune donnée trouvée"
    }
  },
  "date_picker": {
    "all_time": "Toute la période",
    "confirm": "Confirmer",
    "current_quarter": "Trimestre en cours",
    "date_range": "{startDate} - {endDate}",
    "last_n_days": "Ces {days} derniers jours",
    "last_n_months": "Ces {months} derniers mois",
    "last_quarter": "Trimestre précédent",
    "last_year": "Année dernière",
    "lifetime": "Depuis le début",
    "this_year": "Cette année",
    "today": "Aujourd’hui"
  },
  "document_viewer": {
    "sidebar_heading": "Vue d’ensemble du contenu"
  },
  "dynamic_keys": {
    "saml": {
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    }
  },
  "editor": {
    "placeholder": "Écrivez quelque chose",
    "placeholder_with_options": "Écrivez ou saisissez '/' pour afficher les options"
  },
  "error": {
    "title": "Une erreur s’est produite."
  },
  "factor_indicator": {
    "average": "Moyen",
    "bad": "Critique",
    "excellent": "Excellent",
    "good": "Bon"
  },
  "gauge_chart": {
    "empty": {
      "title": "Aucune donnée disponible",
      "tooltip": "Votre score de résilience est en cours de calcul"
    }
  },
  "locale": {
    "current": "Français",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "saml_provider_button": {
    "continue_with": "Continuer avec {provider}"
  },
  "search": {
    "no_options": "Aucune option disponible.",
    "no_results": "Aucun résultat trouvé.",
    "placeholder": "Rechercher..."
  },
  "simulations": {
    "expand_preview": {
      "close": "Fermer l’aperçu",
      "open": "Agrandir l’aperçu"
    }
  },
  "video_player": {
    "captions": "Sous-titres",
    "captions_off": "Désactivés",
    "normal_speed": "Normale",
    "playback_speed": "Vitesse de lecture"
  }
}
